import React, { useState, useEffect, useMemo, useCallback } from 'react';
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  FormControl,
  Input,
  HStack,
  IconButton,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

const PropietarioTesoreria: React.FC = () => {
  const [transactions, setTransactions] = useState([]);
  const [paginatedTransactions, setPaginatedTransactions] = useState([]);
  const [selectedPredio, setSelectedPredio] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [isFetchingTransactions, setFetchingTransactions] = useState(false);
  const toast = useToast();
  
  const fetchPadronData = async () => {
    try {
      const response = await fetch(
        `http://52.91.130.91:5000/api/padron?page=${page}&pageSize=${pageSize}&search=${searchQuery}`,
      );
      const data = await response.json();
      setPaginatedTransactions(data.data);
      setTotalPages(data.pagination.totalPages);
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar los datos del padrón.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const fetchTransactions = async (rfc: string) => {
    setFetchingTransactions(true);
    try {
      const response = await fetch(
        `http://52.91.130.91:5000/api/Transacciones/rfc/${rfc}`,
      );
      const data = await response.json();
      setTransactions(data);
      setFetchingTransactions(false);
      setModalOpen(true); // Abrir modal después de obtener las transacciones
    } catch (error) {
      toast({
        title: 'Error',
        description: 'No se pudieron cargar las transacciones.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
      setFetchingTransactions(false);
    }
  };
  const user = useSelector((state: RootState) => state.auth.user);

  const handleRowClick = async (padron: any) => {
    setSelectedPredio(padron);
    if (padron.rfc) {
      await fetchTransactions(padron.rfc); // Consultar transacciones
    } else {
      toast({
        title: 'Advertencia',
        description: 'El padrón seleccionado no tiene un RFC asociado.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchPadronData();
  }, [page, pageSize, searchQuery]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setPage(1);
  };
  const downloadExcel = useCallback(() => {
    // Formatear los datos para exportación
    const formattedData = paginatedTransactions.map((item: any) => ({
      ID: item.id,
      Nombre: item.nombre_completo,
      RFC: item.rfc,
      Email: item.correo_electronico,
      Teléfono: item.telefono,
      Domicilio: item.domicilio,
      Procedencia: item.lugar_procedencia,
    }));
  
    try {
      // Crear la hoja y el libro
      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Padron de Ciudadanos');
  
      // Descargar el archivo
      XLSX.writeFile(wb, 'Padron.xlsx');
    } catch (error) {
      console.error('Error al generar el archivo Excel:', error);
      toast({
        title: 'Error',
        description: 'No se pudo generar el archivo Excel.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  }, [paginatedTransactions, toast]);
  
  return (
    <Box
      p={8}
      bg="gray.50"
      borderRadius="md"
      boxShadow="md"
      maxW="1200px"
      mx="auto"
      mt={8}
    >
      <Heading as="h1" size="lg" color="teal.500" mb={6} textAlign="center">
        Padrón Ciudadano
      </Heading>

      <FormControl id="search" mb={4}>
        <HStack>
          <Input
            placeholder="Buscar..."
            value={searchQuery}
            onChange={handleSearch}
          />
        </HStack>
      
      </FormControl>

      <Box overflowX="auto">
      <HStack spacing={4}>
          <Menu>
          {user.rol == 'A1' &&

            <MenuButton
              as={Button}
              rightIcon={<ChevronDownIcon />}
              colorScheme="yellow"
            >
              Reportes
            </MenuButton>
}
            <MenuList>
              {/* <MenuItem onClick={onModalOpen}>Nuevo</MenuItem> */}
             
              <MenuItem onClick={downloadExcel}>Descargar XLS</MenuItem>
            </MenuList>
          </Menu>
        </HStack>
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>ID Sys.</Th>
              <Th>Nombre Completo</Th>
              <Th>RFC</Th>
              <Th>EMAIL</Th>
              <Th>TELEFONO</Th>
              <Th>DOMICILIO</Th>
              <Th>LUGAR PROCEDENCIA</Th>
            </Tr>
          </Thead>
          <Tbody>
            {paginatedTransactions.map((padron: any) => (
              <Tr
                key={padron.id}
                onClick={() => handleRowClick(padron)}
                style={{ cursor: 'pointer' }}
              >
                <Td>{padron.id}</Td>
                <Td>{padron.nombre_completo}</Td>
                <Td>{padron.rfc}</Td>
                <Td>{padron.correo_electronico}</Td>
                <Td>{padron.telefono}</Td>
                <Td>{padron.domicilio}</Td>
                <Td>{padron.lugar_procedencia}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

      <HStack spacing={4} mt={4} justifyContent="center">
        <IconButton
          icon={<ChevronLeftIcon />}
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          isDisabled={page === 1}
          aria-label="Página anterior"
        />
        <Box>
          Página {page} de {totalPages}
        </Box>
        <IconButton
          icon={<ChevronRightIcon />}
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          isDisabled={page === totalPages}
          aria-label="Página siguiente"
        />
      </HStack>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        size="4xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            Transacciones del RFC: {selectedPredio?.rfc}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {isFetchingTransactions ? (
              <Text>Cargando transacciones...</Text>
            ) : transactions.length > 0 ? (
              <Table variant="striped" colorScheme="gray">
                <Thead>
                  <Tr>
                    <Th>ID</Th>
                    <Th>Concepto</Th>
                    <Th>Razón Social</Th>
                    <Th>Método de Pago</Th>
                    <Th>Monto</Th>
                    <Th>Fecha</Th>
                    <Th>Estatus</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {transactions.map((transaction: any) => (
                    <Tr key={transaction.ID}>
                      <Td>{transaction.ID}</Td>
                      <Td>{transaction.Concepto}</Td>
                      <Td>{transaction.RazonSocial}</Td>
                      <Td>{transaction.MetodoPago}</Td>
                      <Td>${transaction.Monto?.toFixed(2)}</Td>
                      <Td>
                        {new Date(transaction.Fecha).toLocaleDateString()}
                      </Td>
                      <Td>
                        {transaction.estatus_pago ? 'Pagado' : 'Pendiente'}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <Text>No se encontraron transacciones para este RFC.</Text>
            )}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={() => setModalOpen(false)}>
              Cerrar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default PropietarioTesoreria;
